const DATE_FORMATTER = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
});

export function formatReportDate(value: string): string {
  return DATE_FORMATTER.format(new Date(`${value}T00:00:00Z`));
}

export function formatReportWeekRange(weekStart: string, weekEnd: string): string {
  return `${formatReportDate(weekStart)} - ${formatReportDate(weekEnd)}`;
}
